import React from 'react';
import Divider from '@material-ui/core/Divider';
import { Drawer, Card, Row, Col, Switch } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import { DeleteOutline } from '@material-ui/icons';
import { useHistory } from 'react-router';
import CButton from '../Button';
import {
  removeItemFromCart,
  toggleCartDrawer,
  updateItemInCart,
  clearCart
} from '../../actions/cartAction';
import { confirmPayment } from '../../services/domain';

function sumUpItem(item) {
  let total = item.price;

  item.extra.forEach((extra) => {
    if (extra.enabled) {
      total += extra.price;
    }
  });

  return total;
}

const CartItem = ({ item }) => {
  const dispatch = useDispatch();
  const { title, period, extra } = item;

  const onItemDelete = () => {
    dispatch(removeItemFromCart(title));
  };

  const onExtraChange = (index) => {
    return () => {
      item.extra[index].enabled = !item.extra[index].enabled;

      dispatch(
        updateItemInCart(title, {
          ...item,
          extra: [...item.extra]
        })
      );
    };
  };

  return (
    <Card
      actions={[
        <Row
          key={item}
          justify="space-between"
          style={{ paddingLeft: '24px', paddingRight: '24px' }}
        >
          <Col>Price</Col>
          <Col>{`$${sumUpItem(item)} / ${period}`}</Col>
        </Row>
      ]}
      bodyStyle={{ padding: '0', paddingLeft: '24px', paddingRight: '24px' }}
      extra={<DeleteOutline onClick={onItemDelete} />}
      headStyle={{
        textAlign: 'start'
      }}
      style={{
        borderRadius: '8px',
        marginTop: '16px'
      }}
      title={title}
    >
      {extra.map(({ title, subtitle, enabled }, index) => {
        return (
          <div key={index} style={{}}>
            <Row justify="space-between" style={{ paddingBottom: '18px', paddingTop: '18px' }}>
              <Col>{title}</Col>
              <Col>
                <Switch defaultChecked={enabled} onChange={onExtraChange(index)} />
              </Col>
            </Row>
            <div style={{ marginBottom: '16px', textAlign: 'start' }}>
              <span>{subtitle}</span>
            </div>
            {index !== extra.length - 1 && <Divider />}
          </div>
        );
      })}
    </Card>
  );
};

const CartFooter = ({ items, onCheckOut }) => {
  let total = 0;

  items.forEach((item) => {
    total += sumUpItem(item);
  });

  return (
    <div>
      <Row justify="space-between">
        <Col>Total price</Col>
        <Col>{`$${total}`}</Col>
      </Row>
      <CButton
        disabled={!items.length}
        onClick={onCheckOut}
        type="primary"
        xstyle={{ height: '40px', marginTop: '24px', width: '100%' }}
      >
        Check Out
      </CButton>
    </div>
  );
};

const Cart = ({ getRef, visible }) => {
  const items = useSelector(({ cart }) => cart.items);
  const dispatch = useDispatch();
  const history = useHistory();

  const toogleCartOpen = () => {
    dispatch(toggleCartDrawer());
  };

  const onCheckOut = async () => {
    await confirmPayment(items);
    dispatch(clearCart());
    history.push('/domains');
  };

  return (
    <Drawer
      closable
      destroyOnClose
      drawerStyle={{}}
      footer={<CartFooter items={items} onCheckOut={onCheckOut} />}
      getContainer={getRef}
      mask={false}
      onClose={toogleCartOpen}
      placement="right"
      style={{ position: 'absolute', width: '100%' }}
      title={items.length ? `Your Cart (${items.length} items)` : 'Your Cart'}
      visible={visible}
    >
      {!items.length && <div>Your cart is empty</div>}
      {items.map((item, index) => {
        return <CartItem key={index} item={item} />;
      })}
    </Drawer>
  );
};

export default Cart;
